import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {CouponListWrapper} from './coupon-usage-list/CouponList'
import {QueryRequestProvider} from './coupon-usage-list/core/QueryRequestProvider'
import {QueryResponseProvider} from './coupon-usage-list/core/QueryResponseProvider'
import {ListViewProvider} from './coupon-usage-list/core/ListViewProvider'
import {ContextProvider} from './coupon-usage-list/ContextProvider'
import {useContext} from 'react'
import {AlertContext} from '../../../../_metronic/layout/components/alert-context'
import {AlertBox} from '../../../../_metronic/layout/components/alert-message'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Coupon Usage',
    path: '/coupon-usage',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const AlertDisplay = () => {
  const {show, message, type} = useContext(AlertContext)
  return <>{show && <AlertBox type={type == '1' ? 'success' : 'error'} message={message} />}</>
}

const CouponUsagePage = () => {
  return (
    <QueryRequestProvider>
      <QueryResponseProvider>
        <ListViewProvider>
          <ContextProvider>
            <AlertDisplay />
            <Routes>
              <Route element={<Outlet />}>
                <Route
                  index
                  element={
                    <>
                      <PageTitle breadcrumbs={usersBreadcrumbs}>Coupon Usage List</PageTitle>
                      <CouponListWrapper />
                    </>
                  }
                />
              </Route>
            </Routes>
          </ContextProvider>
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export default CouponUsagePage
